import React from 'react';
import { Navigate } from 'react-router-dom';
import { useOrganizationRoadmaps, useRoadmapStatus } from '@hooks/roadmaps';
import { RoadmapsWelcomePage } from './RoadmapsWelcomePage';

export const RoadmapRouter: React.FC = () => {
  const { data: roadmapStatus, isLoading: statusLoading, isError: statusError } = useRoadmapStatus();
  const status = roadmapStatus ?? 0;
  const { data: roadmaps, isLoading, isError } = useOrganizationRoadmaps({
    enabled: status === 1,
  });

  // Loading state
  if (isLoading || statusLoading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-lg text-gray-600">Loading roadmaps...</div>
      </div>
    );
  }

  // Error state
  if (isError) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-lg text-red-600">
          Error loading roadmaps. Please try again later.
        </div>
      </div>
    );
  }

  switch(status) {
    case 0: // Draft
        return <Navigate to={`/roadmaps/draft`} />
      break;
    case 1: // Published
      {
        const firstRoadmap = roadmaps ? roadmaps[0] : null;
        if (firstRoadmap)
          return <Navigate to={`/roadmaps/${firstRoadmap.id}`} />;
      }
      break;
    case 2: // Archived
    case 3: // No roadmaps
      return <RoadmapsWelcomePage />;
  }

  // No roadmaps exist, show welcome page
  return <RoadmapsWelcomePage />;
};